import React from 'react'

import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';
import { mainRouteInitial } from '../../Data/Constant';

const LoginPR = ({ children }) => {
         const isVendorUserRole = Cookies.get('NIGHT_EYE_USER_ROLE');
         const isDepartmentUserRole = Cookies.get('DP_NIGHT_EYE_USER_ROLE');
         const isLoginUserID = Cookies.get('NIGHT_EYE_USER_ID');
         if(isLoginUserID &&isDepartmentUserRole ){
            return <Navigate to={`/${mainRouteInitial}/ComplianceDashboard`} replace />
         }
         if(isLoginUserID &&isVendorUserRole ){
            return <Navigate to={`/${mainRouteInitial}/VendorDashboard`} replace />
         }

         return <>{children}</>
}

export default LoginPR
